import { inject, Injectable } from '@angular/core';
import { RoomByRoomApiService } from './room-by-room-api.service';
import { ConfigurationFields } from '../models';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class RoomByRoomService {
    private apiService = inject(RoomByRoomApiService);

    public getConfiguration$(): Observable<any> {
        const fields = [ConfigurationFields.Flows, ConfigurationFields.Customization, ConfigurationFields.Features];
        const params = { fields };
        return this.apiService.getConfiguration$(params);
    }
}
